import { render, staticRenderFns } from "./LearnVideo.vue?vue&type=template&id=43450b2a&"
import script from "./learnvideo?vue&type=script&lang=js&"
export * from "./learnvideo?vue&type=script&lang=js&"
import style0 from "./LearnVideo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports